export default function getTooltip(term: string, val?: any) {
  switch (term) {
    case "Eligible":
      return "Eligibility Confirmed";
    case "Small Group Eligibility":
      return "The insurance companies require very small businesses to meet certain criteria to qualify for small group health insurance.";
    case "Fixed Copay":
      return "These services are covered by a defined copay, and not subject to your deductible.";
    case "Deductible":
      return "The insurance only kicks in after you have paid enough from your own pocket to meet the deductible. Some procedures, like preventive care, waive the deductible, meaning that the insurance helps pay for the cost immediately. No matter what happens, you'll never have to pay more than the maximum yourself.";
    case "Subject to Deductible":
      return "For these services, you pay the full contracted rate for the service until you reach your annual deductible.";
    case "Am I Eligible?":
      return "Some carriers have restrictions on what type of companies are eligible for small group health insurance.";
    case "Estimated Doctor Visit":
      return "This is about how much you should expect to pay if you visit the doctor when you are sick. Annual check-ups are free. This takes into account the deductible and coinsurance rates.";
    case "Estimated Prescription Drugs":
      return "This is about how much you should expect to pay to get a prescription filled. It may also be possible to find generic replacements for brand-name drugs which can cost much less.";
    case "Estimated Hospitalization":
      return "This is about how much you should expect to pay if you spent 4 nights in a hospital. Notice that no matter how high the bill might be, you don't need to pay more than the Annual Out-of-Pocket Limit.";
    case "Summary of Benefits":
      return "Download a PDF of this plan's Summary of Benefits & Coverage.";
    case "Annual Out-of-Pocket Limit":
      return "The maximum cost you would be responsible for each year. No matter how expensive your treatments are, you will not pay more than this amount.";
    case "Coinsurance":
      return "You pay 100% of costs until you reach the deductible (with some exceptions; see below), then you pay this percentage of costs until you reach the annual limit. The individual services listed below have more specific information.";
    case "Drug Deductible":
      return "This is the amount that each individual must pay for all prescriptions before the insurance company starts sharing the cost.";
    case "Lifetime Maximum":
      return "There is no limit to how much the insurance company will pay after you reach your individual annual limit.";
    case "Health Savings Account (HSA) Eligible":
      return "HSAs allow you to use pre-tax money to pay for medical expenses. If you have significant medical expenses, an HSA plan can help save up to 30% of the cost.";
    case "Application Fee":
      return "There is no fee to apply for health insurance beyond the premium amounts.";
    case "Office Visit":
      return "This includes visits when you are sick. Annual check-ups are fully covered by the insurance company.";
    case "Specialist Visit":
      return "Some insurance plans require approval from your primary care physician before you can visit a specialist; see below.";
    case "Primary Care Doctor Required":
      return 'Some insurance plans require that you designate a doctor as your "primary" doctor, and visit them first before seeking more specialized care.';
    case "Specialist Referrals Required":
      return "Some insurance plans require that your primary doctor approves visits to specialists.";
    case "Generic Drugs":
      return 'This includes prescriptions that the insurance company has listed as "generic". Your doctor can prescribe brand name or generic equivalents for many drugs.';
    case "Brand Drugs":
      return 'This includes prescriptions that the insurance company has listed as "brand-name". Your doctor can prescribe brand name or generic equivalents for many drugs.';
    case "Non-Formulary Drugs":
      return "This includes all prescriptions that are not listed on the insurance company's approved drugs list.";
    case "Annual Physical":
      return "An annual check-up to screen for potential health problems is covered at no cost to you.";
    case "Annual OB/GYN Checkup":
      return "An annual OB/GYN visit to screen for potential health problems is covered at no cost to you.";
    case "Well Baby Care":
      return "Check-ups to ensure that your newborn is healthy are covered at no cost to you.";
    case "Emergency Room":
      return "This details the specific way that the insurance company shares the cost of this medical expense with you.";
    case "Labs, Tests, and Scans":
      return "This details the specific way that the insurance company shares the cost of this medical expense with you.";
    case "Outpatient Surgery":
      return "This details the specific way that the insurance company shares the cost of this medical expense with you.";
    case "Hospitalization":
      return "This details the specific way that the insurance company shares the cost of this medical expense with you.";
    case "Out of Country Coverage":
      return "This details the specific way that the insurance company shares the cost of this medical expense with you.";
    case "Out of Network Coverage":
      return "Some health plans do not provide coverage outside of the recommended network. Note that if you are unconcious and taken to an emergency room, it will always be covered.";
    case "Out-of-Network Authorization Required":
      return "Some health plans provide coverage outside of the recommended network, but only with a referral from your primary care physician.";
    case "Out-of-Network Deductible":
      return "This details the specific way that the insurance company shares the cost of this medical expense with you.";
    case "Out-of-Network Coinsurance":
      return "This details the specific way that the insurance company shares the cost of this medical expense with you.";
    case "Out-of-Network Out-of-Pocket Limit":
      return "This details the specific way that the insurance company shares the cost of this medical expense with you.";
    case "Chiropractic":
      return "This details the specific way that the insurance company shares the cost of this medical expense with you.";
    case "Mental Health":
      return "This details the specific way that the insurance company shares the cost of this medical expense with you.";
    case "Substance Abuse":
      return "This details the specific way that the insurance company shares the cost of this medical expense with you.";
    case "Pre & Post Natal Office Visits":
      return "This details the specific way that the insurance company shares the cost of this medical expense with you.";
    case "Labor & Delivery Hospital Stay":
      return "This details the specific way that the insurance company shares the cost of this medical expense with you.";
    case "Sample Quote":
      return "Insurance rates are based on zip code and age. Prices shown are based on rates for a 30 year old in your zip code. To see precise prices for your group, please enter employee ages.";
    case "Network Strength":
      switch (val) {
        case 4:
          return "A very broad network. Almost all traditional doctors and hospitals will be in-network.";
        case 3:
          return "A large network. Not every doctor and hospital will be in-network, but you will have plenty of options.";
        case 2:
          return "A medium-sized network. You will have to choose from a limited set of doctors, but you'll have a number of options.";
        case 1:
          return "A narrow network. You will need to choose from a limited pool of doctors, but there will be doctors/hospitals near you.";
        default:
          return "Networks have different regional, state, and nationwide coverage.  The more stars, the stronger the network.";
      }

    case "Doctor Search":
      return "Not all doctors accept all insurance plans.  Use these tools to make sure you're covered with your doctor."; // TODO: Get better copy
    case "Eligible Employee":
      return '"Eligible" means anyone who qualifies for health insurance, usually all full-time employees.';
    case "Required Employee Documentation":
      return "The insurance company requires that all eligible employees be accounted for. It's ok if they decline coverage, but we need to document that they had the option to enroll.";
    case "Two Employees Required":
      return "If you only have one employee enrolling, be sure to also add the owner and any employees who will decline coverage.";
    case "Auto Pay":
      return "If no, you will have to pay your bill via check or online bill pay monthly";
    case "Hospital Reported Insurer Rate":
      return "The published cost of a procedure from a medical facility.";
    default:
      return null;
  }
}
